var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.$store.state.healthyHabits.chart.measurable
        ? _c("div", { staticClass: "text-center my-5" }, [
            _c(
              "h4",
              { style: { color: _vm.$store.state.healthyHabits.chart.color } },
              [_vm._v(_vm._s(_vm.$t("goal")))]
            ),
            _vm._v(" "),
            _vm.showDailyProgressBar
              ? _c(
                  "div",
                  { staticClass: "my-4" },
                  [
                    _c("h5", [_vm._v(_vm._s(_vm.$t("day")))]),
                    _vm._v(" "),
                    _c(
                      "b-progress",
                      {
                        staticClass: "b-progress-statistics",
                        attrs: {
                          "show-progress": "",
                          max: _vm.$store.state.healthyHabits.chart.goal
                        }
                      },
                      [
                        _c(
                          "b-progress-bar",
                          {
                            style: {
                              "background-color":
                                _vm.$store.state.healthyHabits.chart.color
                            },
                            attrs: { value: _vm.getBarTotalCountDay }
                          },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.getBarTotalCountDay))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-progress-bar",
                          {
                            attrs: {
                              variant: "info",
                              value:
                                _vm.$store.state.healthyHabits.chart.goal -
                                _vm.getBarTotalCountDay
                            }
                          },
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.getBarValueFixed(
                                    _vm.$store.state.healthyHabits.chart.goal -
                                      _vm.getBarTotalCountDay
                                  )
                                )
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showWeeklyProgressBar
              ? _c(
                  "div",
                  { staticClass: "my-4" },
                  [
                    _c("h5", [_vm._v(_vm._s(_vm.$t("week")))]),
                    _vm._v(" "),
                    _c(
                      "b-progress",
                      {
                        staticClass: "b-progress-statistics",
                        attrs: {
                          "show-progress": "",
                          max: _vm.getWeeklyMaxGoal
                        }
                      },
                      [
                        _c(
                          "b-progress-bar",
                          {
                            style: {
                              "background-color":
                                _vm.$store.state.healthyHabits.chart.color
                            },
                            attrs: { value: _vm.getBarTotalCountWeek }
                          },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.getBarTotalCountWeek))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-progress-bar",
                          {
                            attrs: {
                              variant: "info",
                              value:
                                _vm.getWeeklyMaxGoal - _vm.getBarTotalCountWeek
                            }
                          },
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.getBarValueFixed(
                                    _vm.getWeeklyMaxGoal -
                                      _vm.getBarTotalCountWeek
                                  )
                                )
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showMonthlyProgressBar
              ? _c(
                  "div",
                  { staticClass: "my-4" },
                  [
                    _c("h5", [_vm._v(_vm._s(_vm.$t("month")))]),
                    _vm._v(" "),
                    _c(
                      "b-progress",
                      {
                        staticClass: "b-progress-statistics",
                        attrs: {
                          "show-progress": "",
                          max: _vm.getMonthlyMaxGoal
                        }
                      },
                      [
                        _c(
                          "b-progress-bar",
                          {
                            style: {
                              "background-color":
                                _vm.$store.state.healthyHabits.chart.color
                            },
                            attrs: { value: _vm.getBarTotalCountMonth }
                          },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.getBarTotalCountMonth))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-progress-bar",
                          {
                            attrs: {
                              variant: "info",
                              value:
                                _vm.getMonthlyMaxGoal -
                                _vm.getBarTotalCountMonth
                            }
                          },
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.getBarValueFixed(
                                    _vm.getMonthlyMaxGoal -
                                      _vm.getBarTotalCountMonth
                                  )
                                )
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "my-4" },
              [
                _c("h5", [_vm._v(_vm._s(_vm.$t("year")))]),
                _vm._v(" "),
                _c(
                  "b-progress",
                  {
                    staticClass: "b-progress-statistics",
                    attrs: { "show-progress": "", max: _vm.getYearlyMaxGoal }
                  },
                  [
                    _c(
                      "b-progress-bar",
                      {
                        style: {
                          "background-color":
                            _vm.$store.state.healthyHabits.chart.color
                        },
                        attrs: { value: _vm.getBarTotalCountYear }
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.getBarTotalCountYear))])]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-progress-bar",
                      {
                        attrs: {
                          variant: "info",
                          value: _vm.getYearlyMaxGoal - _vm.getBarTotalCountYear
                        }
                      },
                      [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.getBarValueFixed(
                                _vm.getYearlyMaxGoal - _vm.getBarTotalCountYear
                              )
                            )
                          )
                        ])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "text-center my-5" }, [
        _c(
          "h4",
          { style: { color: _vm.$store.state.healthyHabits.chart.color } },
          [_vm._v(_vm._s(_vm.$t("summary")))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "pie no-round",
            style: {
              "--p": _vm.$store.state.healthyHabits.chart.score.currentValue,
              "--c": _vm.$store.state.healthyHabits.chart.color,
              "--b": "10px",
              color: _vm.$store.state.healthyHabits.chart.color
            }
          },
          [
            _vm._v(
              _vm._s(_vm.$store.state.healthyHabits.chart.score.currentValue) +
                "%"
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { class: { "inline-block": !_vm.showMobileStreaks } }, [
          _c("span", { staticClass: "mr-2" }, [
            _vm._v(_vm._s(_vm.$t("remaining")) + ": "),
            _c(
              "span",
              {
                style: {
                  color: _vm.$store.state.healthyHabits.chart.color,
                  "font-weight": "bold"
                }
              },
              [
                _vm._v(
                  _vm._s(
                    100 -
                      _vm.$store.state.healthyHabits.chart.score.currentValue
                  ) + "%"
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("span", [
            _vm._v(_vm._s(_vm.$t("total")) + ": "),
            _c(
              "span",
              {
                style: {
                  color: _vm.$store.state.healthyHabits.chart.color,
                  "font-weight": "bold"
                }
              },
              [
                _vm._v(
                  _vm._s(_vm.$store.state.healthyHabits.chart.total) +
                    " " +
                    _vm._s(_vm.$t("days"))
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _vm.showMobileStreaks
          ? _c("div", [
              _c("span", { staticClass: "mr-2" }, [
                _vm._v(_vm._s(_vm.$t("currentStreak")) + ": "),
                _c(
                  "span",
                  {
                    style: {
                      color: _vm.$store.state.healthyHabits.chart.color,
                      "font-weight": "bold"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$store.state.healthyHabits.chart.dataMapped
                          .currentStreak
                      )
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("bestStreak")) + ": "),
                _c(
                  "span",
                  {
                    style: {
                      color: _vm.$store.state.healthyHabits.chart.color,
                      "font-weight": "bold"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$store.state.healthyHabits.chart.dataMapped
                          .bestStreak
                      )
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mt-3" }, [
                _c("div", [
                  _vm._v(_vm._s(_vm.$t("totalWeek")) + ": "),
                  _c(
                    "span",
                    {
                      style: {
                        color: _vm.$store.state.healthyHabits.chart.color,
                        "font-weight": "bold"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.getTotalCountWeek()) +
                          " (" +
                          _vm._s(_vm.getTotalCountWeek(null, true)) +
                          "%)"
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(_vm._s(_vm.$t("totalMonth")) + ": "),
                  _c(
                    "span",
                    {
                      style: {
                        color: _vm.$store.state.healthyHabits.chart.color,
                        "font-weight": "bold"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.getTotalCountMonth()) +
                          " (" +
                          _vm._s(_vm.getTotalCountMonth(null, true)) +
                          "%)"
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(_vm._s(_vm.$t("totalYear")) + ": "),
                  _c(
                    "span",
                    {
                      style: {
                        color: _vm.$store.state.healthyHabits.chart.color,
                        "font-weight": "bold"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.getTotalCountYear()) +
                          " (" +
                          _vm._s(_vm.getTotalCountYear(null, true)) +
                          "%)"
                      )
                    ]
                  )
                ])
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("healthy-habits-calendar"),
      _vm._v(" "),
      Object.keys(this.$store.state.healthyHabits.chart.score.options).length >
      0
        ? _c(
            "div",
            { staticClass: "my-5" },
            [
              _c(
                "div",
                { staticClass: "interval-selector-container" },
                [
                  _c("b-form-select", {
                    staticClass: "interval-selector",
                    attrs: { options: _vm.intervalOptionsScore },
                    on: { change: _vm.scoreIntervalSelected },
                    model: {
                      value:
                        _vm.$store.state.healthyHabits.chart.score.interval,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.$store.state.healthyHabits.chart.score,
                          "interval",
                          $$v
                        )
                      },
                      expression:
                        "$store.state.healthyHabits.chart.score.interval"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("healthy-habits-chart", {
                key:
                  "score-chart-" +
                  _vm.$store.state.healthyHabits.chart.score.key,
                attrs: {
                  showIntervalArrows: "",
                  chartOptions:
                    _vm.$store.state.healthyHabits.chart.score.options
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      Object.keys(this.$store.state.healthyHabits.chart.history.options)
        .length > 0
        ? _c(
            "div",
            { staticClass: "my-5" },
            [
              _c(
                "div",
                { staticClass: "interval-selector-container" },
                [
                  _c("b-form-select", {
                    staticClass: "interval-selector",
                    attrs: { options: _vm.intervalOptions },
                    on: { change: _vm.historyIntervalSelected },
                    model: {
                      value:
                        _vm.$store.state.healthyHabits.chart.history.interval,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.$store.state.healthyHabits.chart.history,
                          "interval",
                          $$v
                        )
                      },
                      expression:
                        "$store.state.healthyHabits.chart.history.interval"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("healthy-habits-chart", {
                key:
                  "history-chart-" +
                  _vm.$store.state.healthyHabits.chart.history.key,
                staticClass: "my-5",
                attrs: {
                  showIntervalArrows: "",
                  chartOptions:
                    _vm.$store.state.healthyHabits.chart.history.options
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      Object.keys(this.$store.state.healthyHabits.chart.frequency.options)
        .length > 0
        ? _c("healthy-habits-chart", {
            staticClass: "my-5",
            attrs: {
              chartOptions:
                _vm.$store.state.healthyHabits.chart.frequency.options
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cdd14374", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cdd14374","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/healthy-habits/HealthyHabitsStatisticsComponents.vue
// module id = 4336
// module chunks = 60